module.exports = __webpack_public_path__ + "img/logo_analytics.d3d38a63.svg";